<template>
	<div id="graph_wrap_box">
		<div class="graphwrap">
			<div class="graphloop">
				<el-carousel>
					 <el-carousel-item v-for="item in banner" key="in">
						<img class="graphloopbg" :src="apiUrl+item.vc_coverphoto"  ref="image"/>
					</el-carousel-item>
				</el-carousel>
				<div class="introduce">

					<h4>ByteV实例</h4>
					<br>
					<!-- <h6>我们提供最专业的行业解决方案</h6> -->
					<!-- <h6>多种分析模板免费提供</h6> -->
				</div>
			</div>
			<div class="graphsearch">
				<div class="graphinp_g">
					<span class="searchbox">
						<input type="text" placeholder="可按项目名称搜索" v-model="graphsearch"/>
						<a class="el-icon-thirdicon-qingchu" v-if="graphsearch" style="cursor: pointer;" @click="resetgraphsearch"></a>
					</span>
					<span  class="searchlogo">
						<button style="cursor: pointer;" @click="search"><i class="el-icon-search"></i></button>
					</span>
					<a class="graphbuttonbox" >
						<span class="sortbytime el-icon-thirdicon-daoxu" @click.stop="sortbytime($event)">
							时间
						</span>

						<span class="sortbyhot el-icon-thirdicon-daoxu" @click.stop="sortbyhot($event)">
							热度
						</span>
					</a>
				</div>
				<!-- 分类列表 -->
				<div class="caseList">
					<div><b>类别:</b></div>
					<div :class="{active:categoryIndex==index}" v-for="(item,index) in caseDataList" @click="caseDatas(item.id)"><b>{{item.name}}</b></div>
				</div>
				<ul class='democontent' id="graph_nodata" ref="content">
					<!-- <div id="graph_nodata1" v-if="!graphList">
						<img src="../assets/images/none.png"/>
					</div> -->
					<div v-for="(item,index) in graphList" :key="index">
						<router-link v-if="item.n_contenttype != 2" :to="{path:'/atlasdetails', query:{uuid:item.vc_contentcode}}" tag='li' :key="item.id" style='cursor: pointer;'>

							<div class="urlbox">
								<img  :src="apiUrl+item.vc_coverphoto" />
								<div class="graphimgmark">
									<div class="Contents">
										{{item.vc_abstract}}
									</div>
								</div>
							</div>
								<div class="viewDiv">
								<h3 style="text-align: left">
									{{item.vc_title}}
								</h3>
								<div style="text-align: right">
									<span class="el-icon-view viewbox"></span> <span class="viewnum">{{item.vc_page_view}}</span>
								</div>
							</div>
							<!-- <div class="bookmark">
								<span id="sourcer">{{item.vc_title}}</span> <span class="el-icon-view viewbox"></span> <span class="viewnum">{{item.vc_page_view}}</span>
							</div> -->
						</router-link>
						<li v-else @click="jumpOutsideChain(item)" style='cursor: pointer;'>
							<div class="urlbox">
								<img :src="apiUrl+item.vc_coverphoto" />
								<div class="graphimgmark">
									<div class="Contents">
										{{item.vc_abstract}}
									</div>
								</div>
							</div>
							<div class="viewDiv">
								<h3 style="text-align: left">
									{{item.vc_title}}
								</h3>
								<div style="text-align: right">
									<span class="el-icon-view viewbox"></span> <span class="viewnum">{{item.vc_page_view}}</span>
								</div>
							</div>

							<!-- <div class="bookmark">
							<span id="sourcer">
										<i class="el-icon-thirdicon-morentouxiang"></i>{{item.vc_source}}
								</span> {{item.vc_page_view}}-->
								<!-- <span id="sourcer"><i class="el-icon-thirdicon-morentouxiang"></i>{{item.vc_source}}</span> <span class="el-icon-view viewbox"></span> <span class="viewnum">{{item.vc_page_view}}</span> -->
							<!-- </div> -->
						</li>
					</div>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				apiUrl:this.apiUrl,
				graphbanner: ['../assets/images/graphbanner1.png', '../assets/images/graphbanner2.png'],
				graphsearch: '',
				graphList: '',		//图谱列表
				graphpage:1,						//页码
				graphmore:true,		//是否还有数据
				listlength:false,
				banner:'',
				uuid:'',
				isloding:false,
				caseDataList:[],
				caseid :'',
				categoryIndex: 0
			}
		},
		created(){
		},
//		watch:{
//
//          graphsearch(val,){//普通的watch监听
//				if(val == ''){
//					this.graphpage = 1;
//					this.graphList = '';
//					this.graphmore = true;
//					this.queryData();
//				}
//          }
//  	},
		mounted(){
			//监听滚动条
			// this.listenerFunction()
			document.getElementsByClassName('commonfoot')[0].style.display='none';
			//获取数据
			this.queryData();
			//获取分类列表
			this.caseList();
		},
		beforeRouteLeave(to, from, next) {
	        from.meta.keepAlive = false;
	        next();
		},
		methods: {

			resetgraphsearch() {
				this.graphsearch = '';
			},

			//时间排序
			sortbytime(event) {
				let hot = document.getElementsByClassName('sortbyhot')[0]
				event.target.style.color = 'white'
				event.target.style.background = '#076CF2'
				hot.style.color = '#818181';
				hot.style.background = 'none'
				let graphListstick = [];
				let graphListunstick = [];
				for(let item=0;item<this.graphList.length;item++){
					if(this.graphList[item]['n_stick']==1){
						graphListstick.push(this.graphList[item])

					}else{
						graphListunstick.push(this.graphList[item])
					}

				}
				graphListunstick.sort(this.compare("dt_createtime"))
				this.graphList=graphListstick.concat(graphListunstick)
//				this.graphList.sort(this.compare("dt_createtime"));
			},

			//热度排序
			sortbyhot(event) {
				let time = document.getElementsByClassName('sortbytime')[0]
				event.target.style.color = 'white'
				event.target.style.background = '#076CF2'
				time.style.color = '#818181';
				time.style.background = 'none'
				let graphListstick = [];
				let graphListunstick = [];
				for(let item=0;item<this.graphList.length;item++){
					if(this.graphList[item]['n_stick']==1){
						graphListstick.push(this.graphList[item])

					}else{
						graphListunstick.push(this.graphList[item])
					}
				}
				graphListunstick.sort(this.compare("vc_page_view"))
				this.graphList=graphListstick.concat(graphListunstick)
			},
			//获取数据方法
			queryData(){
				let _this=this;
				this.$http.get(
					_this.apiUrl+'index.php?m=Api&c=Content&a=atlasList',
					{
						params: {
							"page":this.graphpage,
							"keyword":this.graphsearch,
							'caseid':this.caseid
						}
					}
				).then(response => {

					//进行数据验证
					if(response.body.status != 1){

						//显示错误页面
						return;
					}
					if(typeof response.body.data.advertList != "undefined" && response.body.data.advertList != null && response.body.data.advertList != ""){

						//轮播图
						this.banner = response.body.data.advertList;
					}
					if(typeof response.body.data.atlasList == "undefined" || response.body.data.atlasList == null || response.body.data.atlasList == ""){

						//判断是否请求第一页的数据
						if(this.graphpage == 1){
							//显示空数据页面
							if(!this.graphList){
								if(document.getElementById('nodata_markbox')){
									document.getElementById('graph_nodata').removeChild('nodata_markbox')
								}

							}

							_this.listlength=false;
//							alert('没有数据');

						}else{
							//显示没有数据
							this.graphmore = false;
						}

						return;
					}
					this.graphList = '';
					//判断是否是第一次请求
					if(this.graphList == '' && this.graphpage == 1){
						//直接赋值
						let nodata_markbox=document.getElementById('nodata_markbox')
						this.graphList = response.body.data.atlasList;
						document.getElementsByClassName('commonfoot')[0].style.display='block';
					}else{
						//合并数据
						this.graphList = this.graphList.concat(response.body.data.atlasList);
						document.getElementsByClassName('commonfoot')[0].style.display='block';
					}
					// _this.$nextTick(function() {
						let length1 = _this.graphList.length*1;
						if((length1/6)>0 && length1>0){
							_this.listlength=false;
						}else{
							_this.listlength=true;
						}
					// })
					//
					this.graphList.forEach((item) => {
						if(item.vc_page_view>999){
							item.vc_page_view='999+'
						}
					})

				}).catch((e) => {});
			},
			//获取分类列表
			caseList(){
				this.$http.get(this.apiUrl+'index.php?m=Api&c=Content&a=caseList',).then(response => {
					if(response.body.status  == 1){


					this.caseDataList.push({'name':'全部','id':0});
					var _this = this;
					response.body.data.forEach(function(item,index){
						_this.caseDataList.push({'name':item.name,'id':item.id});
					})


					}

				}).catch((e) => {})
			},
			//搜索
			search(){
				this.graphList = '';
				this.graphpage = 1;		//页码重新设置为1
				this.graphmore = true;
				this.queryData();			//查询数据

			},

			//查看更多
			// more(){
			// 	this.graphpage++;		//页码加一
			// 	this.queryData();			//查询数据
			// },

			//排序(降序)

			compare(prop) {
				return function (obj1, obj2) {
					var val1 = obj1[prop];
					var val2 = obj2[prop];
					if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
							val1 = Number(val1);
							val2 = Number(val2);
					}
					if (val1 > val2) {
							return -1;
					} else if (val1 < val2) {
							return 1;
					} else {
							return 0;
					}
				}
			},
//
			//跳转外链
			jumpOutsideChain(item){
				let tempwindow=window.open();
				let url = item.content;
				let uuid = item.vc_contentcode;
				let _this = this;
			//获取数据
			this.$http.get(
				_this.apiUrl+'index.php? m=Api&c=Content&a=atlasDetail', {
					params: {
						"uuid": uuid,
						'userCode': sessionStorage.getItem('usercode')
					}
				}
			).then(response => {
					item.vc_page_view = response.data.data.vc_page_view;
					tempwindow.location = url;
			}, response => {

			});


			},
			//监听滚动条
			//  listenerFunction(e) {
			// 	 this.scroll = 0;
			// 	document.body.scrollTop = 0;
			// 	document.documentElement.scrollTop = 0;
			// 	document.addEventListener('scroll', this.handleScroll, true);
			// },
			// handleScroll () {
			// 	console.log('ul的高度',this.$refs.content.offsetHeight)
			// 	console.log('当前窗口的高度',document.documentElement.clientHeight)
			// 	this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
			// 	console.log('滚动条的高度',this.scroll)
			// 	console.log(this.listlength)
			// 	if(document.documentElement.clientHeight +this.scroll>=this.$refs.content.offsetHeight &&  this.listlength == false){
			// 		this.listlength = true;
			// 		this.graphpage++;		//页码加一
			// 		this.queryData();		//查询数据
			// 	}
			// },
			caseDatas(id){
				console.log(id)
				this.caseid = id;
				this.categoryIndex = id
				this.graphpage = 1
				this.queryData()

			}
		}
	}
</script>

<style scoped="scoped">

	#graph_nodata1{
		width: 100%;
		height: 500px;
	}
	#graph_nodata1>img{
		display: block;
		margin: 100px auto;
	}
	body{
		height: auto;
	}
	.graph_more_wr{
		width: 100%;height: 100px;float: left; padding-top: 50px;list-style-type:none;background:#f3f3f3;
	}
	#graph_wrap_box .graphloopbg{
		display: block;
		height: 360px;
	}
	#graph_wrap_box {
		background: #F3F3F3;
		box-sizing: border-box;
	}
	#graph_wrap_box>.graphwrap {
		width: 100%;
		background: #F3F3F3;
	}
	#graph_wrap_box .graphbuttonbox{
		position: absolute;width: 169px;height: 34px;margin-top: 20px;margin-right: 5px; display: block;right: 0;line-height: 34px;border: 1px solid #707477;border-radius: 5px;cursor: pointer;
	}
	#graph_wrap_box .el-carousel__container{
		height: 360px;
	}
	.el-carousel__item img{
		display: block;
		width: 100%;
		height: 100%;
		min-width: 1200px;
	}
  .graphwrap .graphsearch{
  	width: 1200px;
  	margin: 0 auto;
  }
  .graphinp_g{
  	margin: 10px 0;
  	height: 70px;
  	width: 1200px;
  	position: relative;
  }
  .caseList{
	height: 70px;
  	width: 1200px;
	background: #fff;
	text-align: left;

  }
  .caseList>div{
	font-size: 15px;
	display: inline;
    width: 200px;
    height: 70px;
	line-height: 70px;
    justify-content: center;
    align-items: center;
	margin-left: 20px;
	padding: 8px;
	cursor: pointer;
  }
  .graphinp_g>.searchbox{
  	float: left;
	position: relative;
	border: 1px solid #999;
	border-right: 0;
	border-radius:5px 0 0 5px;
	margin-top: 20px;
	margin-left: 5px;
	display: inline-block;
	width: 45%;
	height: 30px;
	top: 0;
  }
  .graphinp_g>.searchlogo{
  	float: left;
	border: 1px solid #076CF2;
	border-left: 0;
	border-radius:0 5px 5px 0;
	margin-top: 20px;
	margin-right: 30px;
	display: inline-block;
	width:7%;
	height: 30px;
	background: #076CF2;
  }
  .graphwrap .graphsearch{
  	width: 1200px;
  	margin: 0 auto;
  }
  .graphinp_g{
  	margin: 10px 0;
  	height: 70px;
  	width: 1200px;
  	position: relative;
  }
  .graphinp_g>.searchlogo{
  	float: left;
	border: 1px solid #076CF2;
	border-left: 0;
	border-radius:0 5px 5px 0;
	margin-top: 20px;
	margin-right: 30px;
	display: inline-block;
	width:7%;
	height: 30px;
	background: #076CF2;
  }
	.graphwrap .graphsearch {
		width: 1200px;
		margin: 0 auto;
	}

	.graphinp_g {
		margin-top: 28px;
		height: 70px;
		width: 1200px;
		position: relative;
	}

	.graphinp_g>.searchbox {
		float: left;
		position: relative;
		border: 1px solid #999;
		border-right: 0;
		border-radius: 5px 0 0 5px;
		margin-top: 20px;
		/*margin-left: 5px;*/
		display: inline-block;
		width: 610px;
		height: 40px;
		top: 0;
	}

	.sortbytime {
		float: left;
		line-height: 34px;
		color: white;
		display: block;
		width:85px;
		height: 34px;
		background: #076CF2;
	}

	.sortbyhot {
		float: right;
		line-height: 34px;
		color: #818181;
		display: block;
		width: 84px;
		height: 34px;
		background: ;
	}

	.graphinp_g>.searchlogo {
		float: left;
		border: 1px solid #076CF2;
		border-left: 0;
		border-radius: 0 5px 5px 0;
		margin-top: 20px;
		margin-right: 30px;
		display: inline-block;
		width: 86px;
		height: 40px;
		background: #076CF2;
	}

	.graphinp_g>.searchbox>input {
		display: block;
		padding: 0;
		margin: 0;
		border: 0;
		background: rgba(0, 0, 0, 0);
		outline: none;
		width:510px;
		height: 100%;
		float: left;
		text-indent: 12px;
	}

	.graphinp_g>.searchbox>a {
		width: 80px;
		height: 40px;
		display: block;
		float: right;
		font-size: 24px;
		line-height: 40px;
	}

	.searchlogo button {
		margin: 0;
		border: 0;
		background: rgba(0, 0, 0, 0);
		outline: none;
		width: 100%;
		height: 100%;
	}
	.searchlogo button>i{
		font-size: 24px;color: white;
	}
	.graphwrap .democontent li {
		position: relative;
		list-style: none;
		background: white;
		width: 390px;
		height: 325px;

		float: left;
		box-shadow: 2px 2px 4px #F2DEDE;
	}
	.graphwrap .democontent>div{
		margin: 12px 0;
		float: left;
	    width: 400px;
	    height: 340px;
	    background: #f3f3f3;
	}
	.graphwrap .democontent li>h3 {
		padding: 0 8px;
		width: 374px;
		height: 45px;
		line-height: 45px;
		font-size: 14px;
		color: #222222;
		text-align: left;
	}
	#graph_wrap_box .democontent{
		margin-top: 8px;
		overflow: hidden;
		padding-bottom:30px ;
		min-height: 700px;
	}
	.graphwrap .democontent li>.bookmark {
		position: relative;
		border-top: 1px solid #F3F3F3;
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #B3B3B3;
		text-align: right;
	}
	.viewbox{
		display: inline-block;
		height: 40px;
		width: 14px;
		line-height: 40px;
		text-align: right;
	}
	.viewnum{
		margin-right: 5px;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		text-align: right;
	}
	.graphwrap #sourcer {
		height: 40px;
		line-height: 40px;
		position: absolute;
		font-size: 14px;
		color: #222222;
		left: 10px;
		padding-left: 40px;
		width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
	}

	.graphwrap #sourcer>i {
		position: absolute;
		height: 40px;
		line-height: 40px;
		left: 0;
		display: block;
		font-size: 30px;
	}

	.graphwrap .urlbox {
		margin: 8px 8px 3px 8px;
		width: 374px;
		height: 275px;
		background: #F3F3F3;
		position: relative;
	}

	.graphwrap .urlbox>img{
		display: block;
		width: 100%;
		height: 100%;
	}
	.graphwrap .democontentbox>h3 {
		width: 280px;
		font-size: 18px;
		text-align: left;
		color: #8793A1;
		margin-left: 10px;
	}
	.graphwrap .urlbox>.graphimgmark {
		overflow: hidden;
		word-wrap: break-word;
		background: rgba(0, 0, 0, .5);
		width: 374px;
		height: 275px;
		position: absolute;
		left: 0;
		top: 0;
		display: none;
		text-align: center;
		color: white;
	}
	.graphwrap .urlbox:hover .graphimgmark{
		display: table;
	}
	.graphwrap .graphimgmark .Contents{
		width: 275px;
		max-height: 170px;
		overflow: hidden;
		padding: 0 20px;
		display: table-cell;
		vertical-align: middle;
		position: absolute;
		top: 50%;
		left: 50%;

		-webkit-transform:translate(-50%,-50%) ;
		-moz-transform: translate(-50%,-50%);
		-ms-transform: translate(-50%,-50%);
		-o-transform: translate(-50%,-50%);
		transform: translate(-50%,-50%);
	}
	.graph_morebtn {
		width: 119px;
		height: 34px;
		margin-top: 10px;
		color: #2978EF;
		cursor: pointer;
		background-color: #F3F3F3;
		border: 1px solid #E1E1E1;
	}
	.el-icon-thirdicon-morentouxiang{
		color: #B6CDEB;
	}
	.introduce{
		color: #efefef;
		position: absolute;
		top: 18%;
		z-index: 2;
		height: 12%;
		bottom: 0;
		right: 0;
		left: 20%;
		font-size: 30px;
		text-align: left;
	}
	.viewDiv{
		display: grid;
		grid-template-columns: 180px 180px;
		height: 40px;
		line-height: 40px;
		padding-left: 10px;
	}
	/* .caseListChild:hover{
		color:#FFF;
		border-radius:12px;
		cursor: pointer;
		background: #2FB3FF;
	} */
	.active {
		color:#FFF;
		border-radius:12px;
		cursor: pointer;
		background: #2FB3FF;
		cursor: pointer;
	}
		.icon{
		width: 30px;
		height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/views/graphPage.vue